<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <!--  <v-btn icon @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn> -->
            <v-btn icon @click="handleBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <!-- modifque  :record-status= y le puse la variable esta antes tenia registro.estatus -->
            <save-btn
              class="btn-oval"
              :record-status="esta"
              :loading="loading"
              @click="guardarYContinuar"
            />
          </v-col>
        </v-row>
        <v-col cols="12">
          <span style="font-size: 30px">🌾</span>
          <div style="text-align: center" class="text-h4">
            {{
              nuevocosecha
                ? 'Crea Nueva Siembra o Cosecha Agrícola'
                : 'Siembra, Cosecha y Venta Agrícola'
            }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-h7">
            1. Agrega o busca una siembra, cosecha o ventas en esta Finca
          </div>
        </v-col>
        <!--  <v-col cols="12">
          <form-meta
            :data="registro"
            :remove-commit="'removerCosecha'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          />
        </v-col> -->
        <!--   <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son requeridos
          </div>
        </v-col> -->
        <!--   <ul>
          <li v-for="(valor, index) in cosecha" :key="index">
            {{ valor }}
          </li>
        </ul>
        <ul>
          <li v-for="(valor, index) in siembraItems" :key="index">
            {{ valor }}
          </li>
        </ul>
        <div>
          <h1>Información Agricola</h1>
          <p>ID Productor: {{ idProductor }}</p>
          <p>ID Finca: {{ idFinca }}</p>
          <p>ID Parcela: {{ idParcela }}</p>
          <p>Fecha: {{ fecha }}</p>
        </div> -->
        <v-col cols="12">
          <v-select
            v-model="vpreparacionid_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            ref="fincaSelect"
            outlined
            dense
            :disabled="busquedaFin"
            @input="onFincaChange()"
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            2. Presiona botón CREA NUEVO para tú nueva Parcela o selecciona una
          </div>
        </v-col>
        <v-row>
          <v-col cols="9">
            <v-select
              v-model="vpreparacionid_parcela"
              :no-data-text="$vuetify.noDataText"
              clearable
              outlined
              dense
              :items="parcelasPorId(vpreparacionid_finca)"
              item-value="id"
              item-text="nombre"
              ref="parcelaSelect"
              label="Parcela *"
              :rules="[r.required]"
              :disabled="busquedaFin"
              @input="onParcelaChange()"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <div class="justify-end">
              <modal-parcela />
            </div>
          </v-col>
        </v-row>
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            3. Fecha que Inicio esta Producción: Ejemplo: 2025-01-30
          </div>
        </v-col>
        <v-col cols="9">
          <v-combobox
            ref="fechaInicio"
            v-model="vpreparacionfecha"
            :items="fechasSugeridas"
            label="Fecha que inicio la preparación *"
            range-type="production"
            :rules="[r.required]"
            :date.sync="vpreparacionfecha"
            placeholder="aaaa-mm-dd"
            outlined
            dense
            :disabled="busquedaFin"
            @change="validarFecha"
          />
          <p v-if="errorin" style="color: red">{{ errorin }}</p>
        </v-col>
        <!--    <v-col cols="2" class="d-flex align-center">
          <v-icon
            @mousedown.prevent="onLupaChange"
            color="primary"
            style="cursor: pointer; font-size: 30px"
          >
            mdi-magnify
          </v-icon>
        </v-col> -->
        <v-col cols="2" class="d-flex align-center">
          <v-btn color="primary" block @mousedown.prevent="onLupaChange">
            4. Siguiente
          </v-btn>
        </v-col>
        <!-- Mensaje de estado de búsqueda -->
        <v-col v-if="mensajeBusqueda" cols="12">
          <v-alert
            :type="tipoMensaje"
            :value="true"
            dismissible
            @input="limpiarMensaje"
          >
            {{ mensajeBusqueda }}
          </v-alert>
        </v-col>

        <!-- Indicador de carga -->
        <v-col v-if="buscandoRegistro && !nuevocosecha" cols="12">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          <div class="text-center text-body-2 mt-2">
            Buscando registro existente...
          </div>
        </v-col>

        <v-col cols="12">
          <v-divider
            style="border: 1.5px solid black; margin: 10px 0"
          ></v-divider>
        </v-col>
      </v-row>

      <!-- <v-col cols="6">
          <v-select
            v-model="registro.sistemas"
            multiple
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="sistema_produccion"
            item-text="descripcion"
            item-value="id"
            label="Modo de producción*"
            outlined
          ></v-select>
        </v-col> -->

      <!--         <v-col cols="6">
          <v-select
            v-model="vsiembraREALIZA_TRAZABILIDAD"
            :rules="[r.required]"
            :items="sino"
            item-text="descripcion"
            item-value="id"
            label="Realiza control de trazabilidad*"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="vpreparaciontipo_prima_seguro"
            :no-data-text="$vuetify.noDataText"
            :items="tipo_prima_seguro"
            label="Tipo de prima de seguro"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="vpreparacionfinanciamiento"
            :rules="[r.required]"
            :items="sino"
            item-text="descripcion"
            item-value="id"
            label="Financiamiento"
            outlined
          ></v-select>
          </v-col> -->

      <!-- Sección de Inventario Agricola Actual -->
      <v-row class="pa-2" align="center" justify="space-between">
        <v-col cols="2" class="justify-left">
          <v-btn
            :color="activeTab === 'ingreso' ? 'green darken-3' : 'primary'"
            class="white--text"
            @click="pmostrarSiembra()"
          >
            <v-icon left>mdi-seed</v-icon>
            5.Siembra
          </v-btn>
        </v-col>

        <v-col cols="2" class="justify-center">
          <v-btn
            :color="activeTab === 'engorde' ? 'green darken-3' : 'primary'"
            class="white--text"
            @click="pmostrarCosecha()"
          >
            <v-icon left>mdi-barley</v-icon>
            6.Cosecha
          </v-btn>
        </v-col>

        <v-col cols="2" class="d-flex justify-right">
          <v-btn
            :color="activeTab === 'venta' ? 'green darken-3' : 'primary'"
            class="white--text"
            @click="pmostrarVenta()"
          >
            <span style="font-size: 30px">🛒</span>
            7.Venta
          </v-btn>
        </v-col>
      </v-row>

      <template v-if="nuevocosecha || mostrarRegistro()">
        Selecciona cada botón verde para llenar tu siembra, cosecha y ventas
        <v-row v-if="mostrarSiembra" class="pa-2" justify="start">
          <v-col cols="12" class="mt-n4">
            <div class="subtitle-1 grey--text">
              Presiona el botón Agrega Nueva para agregar la siembra de un
              cultivo.
            </div>
          </v-col>
          <v-col cols="8">
            <v-btn
              block
              rounded
              class="white--text primary--text"
              @click="addSiembraItems"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Nueva Siembra
            </v-btn>
          </v-col>

          <!-- DRAGON -->
          <v-col cols="12" v-if="indexEdicion !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="siembraItems[indexEdicion].ID_CULTIVO"
                    :rules="[r.required]"
                    :items="cultivo"
                    item-text="descripcion"
                    item-value="id"
                    label="Rubro *"
                    outlined
                    ref="tipoGanadoSelect"
                    @change="SiembraChange"
                  >
                    <template v-slot:selection="props">
                      <div v-text="props.item[props.parent.$props.itemText]" />
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    v-model="siembraItems[indexEdicion].VARIEDAD"
                    :items="variedad_cultivo"
                    item-text="variedad_cultivo"
                    item-value="variedad_cultivo"
                    label="variedad*"
                    :rules="
                      siembraItems[indexEdicion].ID_CULTIVO ? [r.required] : []
                    "
                    @change="SiembraChange"
                    outlined
                  >
                  </v-select>
                </v-col>

                <!--  <v-col cols="12" md="3">
                    <v-text-field
                    v-model.number="siembraItems[indexEdicion].superficie_preparada"
                    :rules="
                      siembraItems[indexEdicion].ID_CULTIVO
                        ? [
                            r.required,
                            r.float,
                            (v) =>
                              !alertar_superficie_mayor ||
                              alertar_superficie_mayor,
                          ]
                        : []
                    "
                    label="Sup. preparada*"
                    suffix="Ha"
                    /> 
                   </v-col>-->

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="
                      siembraItems[indexEdicion].SUPERFICIE_ACTUAL_SEMBRADA
                    "
                    :rules="[
                      r.float,
                      (v) =>
                        !alertar_superficie_mayor || alertar_superficie_mayor,
                    ]"
                    label="Superficie sembrada *"
                    outlined
                    suffix="Ha"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="
                      siembraItems[indexEdicion].VOLUMEN_ANUAL_PRODUCCION
                    "
                    :rules="
                      siembraItems[indexEdicion].ID_CULTIVO
                        ? [r.required, r.float]
                        : []
                    "
                    label="Cantidad estimada a Cosechar*"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          siembraItems[indexEdicion].VOLUMEN_ANUAL_PRODUCCION =
                            $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="siembraItems[indexEdicion].FECHA_ESTIMADA_COSECHA"
                    label="Fecha a cosechar *"
                    range-type="production"
                    placeholder="YYYY-MM-DD"
                    :rules="
                      siembraItems[indexEdicion].ID_CULTIVO ? [r.required] : []
                    "
                    @change="validarFechae"
                    outlined
                  >
                  </v-text-field>
                  <p v-if="errorFecha" style="color: red">
                    {{ errorFecha }}
                  </p>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="siembraItems[indexEdicion].CANTIDAD_SEMILLA"
                    :rules="[r.float]"
                    label="Cant semilla"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          siembraItems[indexEdicion].CANTIDAD_SEMILLA = $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="siembraItems[indexEdicion].SEMILLA"
                    :items="semilla"
                    label="Tipo de semilla"
                    outlined
                    @change="SiembraChange"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-alert
                    v-if="errorSiembra"
                    type="error"
                    dense
                    text
                    class="mt-2"
                  >
                    {{ errorSiembra }}
                  </v-alert>
                </v-col>
                <v-col cols="6" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEntrada">
                    Siguiente
                  </v-btn>
                </v-col>
                <v-col cols="6" md="3" class="d-flex">
                  <v-btn icon @click="deleteSiembraItems(indexEdicion)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>

                <!-- <v-col cols="12" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="ocultarFormulario"
                    >Continuar</v-btn
                  >
                  </v-col> -->
              </v-row>
            </v-card>
          </v-col>
          <!-- listado de producciones (entradas) -->
          <v-col cols="12" v-for="(item, index) in siembraItems" :key="index">
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicion
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarProduccion(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Cultivo:</strong>
                    {{ obtenerNombreCultivo(item.ID_CULTIVO) }} - Variedad:
                    {{ item.VARIEDAD || '' }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Semilla: {{ item.SEMILLA }}</span>
                    <span
                      >Superficie Sembrada:
                      {{ item.SUPERFICIE_ACTUAL_SEMBRADA || '' }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Cant Sembrada: {{ item.CANTIDAD_SEMILLA }}</span>
                    <span
                      >Fecha a cosechar:
                      {{ item.FECHA_ESTIMADA_COSECHA || '' }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <!-- Contenedor con scroll horizontal y vertical -->
          <!-- <v-col cols="12">
            <div
              style="
                overflow-y: auto;
                max-height: 400px;
                width: 100%;
                border: 1px solid #ccc;
              "
             > 
              <v-btn @click="addSiembraItems" color="primary"
                ><v-icon left>mdi-plus</v-icon> Agregar</v-btn
              >

              <table class="custom-table">
                <thead>
                  <tr>
                    <th v-for="header in siembraHeaders" :key="header.value">
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
                <tbody> -->
          <!--         <v-data-table
              :headers="siembraHeaders"
              :items="siembraItems"
              item-key="ID"
              class="elevation-1"
              hide-default-footer
              style="min-width: 900px; border-collapse: collapse; margin: auto"
             >
              
              <template v-slot:body>
                  <tr
                    v-for="(item, index) in siembraItems"
                    :key="index"
                    style="border: 1px solid rgb(157, 157, 157)"
                  >-->
          <!--     DRAGON solo el primer td-->
          <!-- <td style="min-width: 150px">
                      <v-btn
                        small
                        color="primary"
                        @click="mostrarFormularioEdicion(index)"
                      >
                        Ver
                      </v-btn>
                    </td>

                    <td style="min-width: 150px">
                      <v-select
                        v-model="item.ID_CULTIVO"
                        :no-data-text="$vuetify.noDataText"
                        :items="cultivo"
                        item-text="descripcion"
                        item-value="id"
                        label="Rubro*"
                        @input="debounceBuscarRegistroExistente"
                      >
                        <template v-slot:selection="props">
                          <div
                            v-text="props.item[props.parent.$props.itemText]"
                          />
                        </template>
                      </v-select>
                    </td>
                    <td style="min-width: 150px">
                      <v-select
                        v-model="item.VARIEDAD"
                        :no-data-text="$vuetify.noDataText"
                        :items="variedad_cultivo"
                        item-text="variedad_cultivo"
                        item-value="variedad_cultivo"
                        label="variedad*"
                        :rules="item.ID_CULTIVO ? [r.required] : []"
                        @input="debounceBuscarRegistroExistente"
                      >
                      </v-select>
                    </td>
                    <td style="min-width: 170px">
                      <v-text-field
                        v-model.number="item.superficie_preparada"
                        :rules="
                          item.ID_CULTIVO
                            ? [
                                r.required,
                                r.float,
                                (v) =>
                                  !alertar_superficie_mayor ||
                                  alertar_superficie_mayor,
                              ]
                            : []
                        "
                        label="Sup. preparada*"
                        suffix="Ha"
                      />
                    </td>
                    <td style="min-width: 200px">
                      <v-text-field
                        v-model.number="item.VOLUMEN_ANUAL_PRODUCCION"
                        :rules="item.ID_CULTIVO ? [r.required, r.float] : []"
                        label="Prod. estima*"
                      >
                        <template v-slot:append>
                          <unit-picker
                            @transform="item.VOLUMEN_ANUAL_PRODUCCION = $event"
                          />
                        </template>
                      </v-text-field>
                    </td>
                    <td style="min-width: 170px">
                      <v-text-field
                        v-model="item.FECHA_ESTIMADA_COSECHA"
                        label="Fecha a cosechar*"
                        range-type="production"
                        placeholder="YYYY-MM-DD"
                        :rules="item.ID_CULTIVO ? [r.required] : []"
                        @change="validarFechae(item)"
                      >
                      </v-text-field>
                      <p v-if="item.errorFecha" style="color: red">
                        {{ item.errorFecha }}
                      </p>
                    </td>
                    <td style="min-width: 170px">
                      <v-text-field
                        v-model.number="item.SUPERFICIE_ACTUAL_SEMBRADA"
                        :rules="[
                          r.float,
                          (v) =>
                            !alertar_superficie_mayor ||
                            alertar_superficie_mayor,
                        ]"
                        label="Sup sembrada"
                        suffix="Ha"
                      />
                    </td>
                    <td style="min-width: 200px">
                      <v-text-field
                        v-model.number="item.CANTIDAD_SEMILLA"
                        :rules="[r.float]"
                        label="Cant semilla*"
                      >
                        <template v-slot:append>
                          <unit-picker
                            @transform="item.CANTIDAD_SEMILLA = $event"
                          />
                        </template>
                      </v-text-field>
                    </td>
                    <td style="min-width: 200px">
                      <v-select
                        v-model="item.SEMILLA"
                        :no-data-text="$vuetify.noDataText"
                        :items="semilla"
                        label="Tipo de semilla"
                      ></v-select>
                    </td>
                    <td style="min-width: 150px">
                      <v-btn @click="deleteSiembraItems(index)" color="red"
                        >Eliminar</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </table> 
            </div>
            </v-col>-->
        </v-row>

        <v-row v-if="mostrarCosecha" justify="center">
          <v-col cols="6">
            <v-btn
              depressed
              block
              rounded
              class="white--text primary--text"
              @click="addCosecha"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Nueva Cosecha
            </v-btn>
          </v-col>
          <v-col cols="12">
            <!-- <div class="text-h6">Cosecha</div> -->
            <div class="subtitle-1 grey--text mt-n4">
              Presiona el botón Agrega Nueva para agregar la cosecha de un
              cultivo.
            </div>
          </v-col>

          <!-- DRAGON -->
          <v-col cols="12" v-if="indexEdicionconsecha !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="cosecha[indexEdicionconsecha].id_cultivo"
                    :no-data-text="$vuetify.noDataText"
                    :rules="[r.required]"
                    :items="cultivo"
                    item-text="descripcion"
                    item-value="id"
                    label="Rubro *"
                    outlined
                    ref="tipoGanadoCosecha"
                    @change="CosechaChange"
                  >
                    <template v-slot:selection="props">
                      <div v-text="props.item[props.parent.$props.itemText]" />
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    v-model="cosecha[indexEdicionconsecha].variedad_cultivo"
                    :items="variedad_cultivo"
                    item-text="variedad_cultivo"
                    item-value="variedad_cultivo"
                    label="variedad*"
                    outlined
                    :rules="
                      cosecha[indexEdicionconsecha].ID_CULTIVO
                        ? [r.required]
                        : []
                    "
                    @change="CosechaChange"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="cosecha[indexEdicionconsecha].fecha"
                    label="Fecha*"
                    outlined
                    range-type="production"
                    :rules="[r.required]"
                    :date.sync="cosecha[indexEdicionconsecha].fecha"
                    placeholder="yyyy-mm-dd"
                    @change="validarFechaCosecha(indexEdicionconsecha)"
                  >
                  </v-text-field>
                  <p v-if="errorFechaCosecha" style="color: red">
                    {{ errorFechaCosecha }}
                  </p>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="
                      cosecha[indexEdicionconsecha].superficie_cosechada
                    "
                    suffix="Ha"
                    :rules="[r.required]"
                    label="Superficie cosechada *"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="cosecha[indexEdicionconsecha].produccion"
                    :rules="[r.required, r.float]"
                    label="Producción *"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          cosecha[indexEdicionconsecha].produccion = $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="cosecha && cosecha[indexEdicionconsecha]"
                >
                  <div>
                    <span>{{
                      calcularRendimiento(cosecha[indexEdicionconsecha])
                    }}</span>
                    <v-icon
                      :color="
                        rendimientoMayorA1(cosecha[indexEdicionconsecha])
                          ? 'green'
                          : 'red'
                      "
                      small
                      class="ml-2"
                    >
                      {{
                        rendimientoMayorA1(cosecha[indexEdicionconsecha])
                          ? 'mdi-arrow-up-bold'
                          : 'mdi-arrow-down-bold'
                      }}
                    </v-icon>
                  </div>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="cosecha[indexEdicionconsecha].superficie_perdida"
                    :rules="[r.required, r.float, r.min_num(0)]"
                    label="Perdida o Merma o Desperdicios*"
                    outlined
                    suffix="Ha"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="cosecha[indexEdicionconsecha].tiempo_produccion"
                    label="Duración"
                    outlined
                  >
                  </v-text-field>
                  <p v-if="errorin" style="color: red">{{ errorin }}</p>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="cosecha[indexEdicionconsecha].semilla"
                    :no-data-text="$vuetify.noDataText"
                    :items="semilla"
                    label="Tipo de semilla"
                    outlined
                    @change="CosechaChange"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-alert
                    v-if="errorCosecha"
                    type="error"
                    dense
                    text
                    class="mt-2"
                  >
                    {{ errorCosecha }}
                  </v-alert>
                </v-col>
                <v-col cols="6" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarCosecha">
                    Siguiente
                  </v-btn>
                </v-col>
                <v-col cols="6" md="3" class="d-flex">
                  <v-btn icon @click="deleteCosecha(indexEdicionconsecha)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>

                <!-- <v-col cols="12" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="ocultarFormulario"
                    >Continuar</v-btn
                  >
                </v-col> -->
              </v-row>
            </v-card>
          </v-col>

          <!-- listado de producciones (entradas) -->
          <v-col cols="12" v-for="(fila, index) in cosecha" :key="index">
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicionconsecha
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarCosecha(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Cultivo:</strong>
                    {{ obtenerNombreCultivocosecha(fila.id_cultivo) }} -
                    Variedad: {{ fila.variedad_cultivo || '' }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Semilla: {{ fila.semilla }}</span>
                    <span
                      >Superficie Cosechada:
                      {{ fila.superficie_cosechada || '' }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Producción: {{ fila.produccion || '' }}</span>
                    <span>Fecha de cosecha: {{ fila.fecha || '' }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <!-- COSECHA -->
        <!-- {{ cosecha }} -->
        <!--  <v-row v-if="mostrarCosecha">
          <v-col cols="12">
            <div class="text-h6">Cosecha</div>
            <div class="subtitle-1 grey--text">
              Agregue los cultivos y peso que cosecha de cada uno
            </div>
            <div
              style="
                overflow-x: auto;
                max-width: 70%;
                height: auto;
                max-height: 400px;
                margin: center;
              "
            >
              <v-data-table
                :headers="cosechaHeaders"
                :items="cosecha"
                item-key="id"
                class="elevation-1"
                hide-default-footer
                style="
                  min-width: 900px;
                  border-collapse: collapse;
                  margin: auto;
                "
              >
                <template v-slot:body>
                  <tr
                    v-for="(item, index) in cosecha"
                    :key="index"
                    style="border: 1px solid rgb(157, 157, 157)"
                  >
                    <td style="min-width: 150px">
                      <v-select
                        v-model="item.id_cultivo"
                        :no-data-text="$vuetify.noDataText"
                        :rules="[r.required]"
                        :items="cultivo"
                        item-text="descripcion"
                        item-value="id"
                        label="Rubro *"
                        @input="debounceBuscarRegistroExistente"
                      >
                        <template v-slot:selection="props">
                          <div
                            v-text="props.item[props.parent.$props.itemText]"
                          />
                        </template>
                      </v-select>
                    </td>
                    <td style="min-width: 150px">
                      <v-select
                        v-model="item.variedad_cultivo"
                        :no-data-text="$vuetify.noDataText"
                        :rules="[r.required]"
                        :items="variedad_cultivo"
                        item-text="variedad_cultivo"
                        item-value="variedad_cultivo"
                        label="Variedad *"
                        @input="debounceBuscarRegistroExistente"
                      >
                      </v-select>
                    </td>
                    <td style="min-width: 130px">
                      <v-text-field
                        v-model="item.fecha"
                        label="Fecha*"
                        range-type="production"
                        :rules="[r.required]"
                        :date.sync="item.fecha"
                        placeholder="yyyy-mm-dd"
                        @change="validarFechaCosecha(item)"
                      >
                      </v-text-field>
                      <p v-if="item.errorFecha" style="color: red">
                        {{ item.errorFecha }}
                      </p>
                    </td>

                    <td style="min-width: 150px">
                      <v-text-field
                        v-model="item.superficie_cosechada"
                        suffix="Ha"
                        :rules="[r.required]"
                        label="Superficie*"
                      />
                    </td>
                    <td style="min-width: 200px">
                      <v-text-field
                        v-model.number="item.produccion"
                        :rules="[r.required, r.float]"
                        label="Producción*"
                      >
                        <template v-slot:append>
                          <unit-picker @transform="item.produccion = $event" />
                        </template>
                      </v-text-field>
                    </td>
                    <td style="min-width: 100px; text-align: center">
                      <div>
                        <span>{{ calcularRendimiento(item) }}</span>
                        <v-icon
                          :color="rendimientoMayorA1(item) ? 'green' : 'red'"
                          small
                          class="ml-2"
                        >
                          {{
                            rendimientoMayorA1(item)
                              ? 'mdi-arrow-up-bold'
                              : 'mdi-arrow-down-bold'
                          }}
                        </v-icon>
                      </div>
                    </td>
                    <td style="min-width: 100px">
                      <v-text-field
                        v-model="item.tiempo_produccion"
                        label="Duración"
                      >
                      </v-text-field>
                      <p v-if="errorin" style="color: red">{{ errorin }}</p>
                    </td>
                    <td style="min-width: 150px">
                      <v-text-field
                        v-model="item.superficie_perdida"
                        :rules="[r.required, r.float, r.min_num(0)]"
                        label="Perdida *"
                        suffix="Ha"
                      ></v-text-field>
                    </td>
                    <td style="min-width: 150px">
                      <v-select
                        v-model="item.semilla"
                        :no-data-text="$vuetify.noDataText"
                        :items="semilla"
                        label="Tipo de semilla"
                      ></v-select>
                    </td>
                    <td style="min-width: 150px">
                      <v-btn @click="deleteCosecha(index)" color="red"
                        >Eliminar</v-btn
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-btn @click="addCosecha" color="primary">Agregar</v-btn>
            </div>
          </v-col>
          </v-row>
        
         -->

        <!-- Situación de desastre -->
        <!-- <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
          </v-col>
          <situacion-de-desastre v-for="(desastre, index) in registro.desastres" :key="desastre.id_trxdano"
          :form="registro.desastres[index]" :modulo="'AGRICOLA'" @eliminar="eliminarDesastre(index)" /> -->
        <!-- listado dinámico de destinos -->
        <!-- AQUI DESPUES TENGO QUE PONER DESTINO 
         :producciones="[{ produccion: registro.produccion }]"-->
        <!-- {{ registro.destinos }} -->
        <div v-if="mostrarVenta">
          LLena cada Venta y conocerás si tu trabajo rinde y te da beneficios.
          <destino
            :destinos.sync="registro.destinos"
            :producciones="[registro.cosecha]"
            :listado-destinos="destino"
            :rubros="cultivo"
            :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
          />
        </div>

        <div v-if="mostrarobserva">
          <v-col cols="6" class="mb-2">
            <v-text-field
              v-model.number="vpreparacioncoa"
              :rules="[r.required, r.int, r.min_num(1), r.max_num(5)]"
              label="Número de COA*"
              outlined
              dense
              :disabled="!esNuevoRegistro"
            />
            <!-- ANTES IVA AQUI ARRIBA @input="debounceBuscarRegistroExistente" -->
          </v-col>
          <v-col cols="10" v-if="siembra.length > 0 && siembra[0].ID_CULTIVO">
            <v-select
              v-model="vsiembratecnologias"
              multiple
              :no-data-text="$vuetify.noDataText"
              :items="tecnologia"
              :rules="[r.required]"
              label="Tecnologías*"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" class="mt-4">
            <div class="text-h6">Observaciones</div>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="vobservacion"
              :rules="[r.max(1000)]"
              label="Tarea_Pendiente, Fecha, Observación"
              auto-grow
              outlined
              rows="1"
            ></v-textarea>
          </v-col>
          <!-- <v-col cols="12">
          <v-select
            v-model="vpreparacion.ley_de_beneficio"
            :no-data-text="$vuetify.noDataText"
            :items="lista_Ley"
            item-text="programa"
            item-value="programa"
            label="Programa"
            outlined
          />
            </v-col> -->
        </div>
      </template>
    </v-form>
    <registro-existente
      :title="'La cosecha ya existe'"
      :description="'Los datos colocados corresponden a una cosecha existente, desea cargar la información de esta cosecha?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import uuid from 'uuid/v4'
import Form from '@/components/js/Form'
import debounce from 'lodash.debounce'
import { mapState, mapGetters } from 'vuex'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import {
  toArray,
  clona,
  isProductionDateValidComparedToRecords,
} from '../../utilidades'
import {
  cosecha,
  danotrx,
  formulario_cosecha,
  formulario_preparacion,
  formulario_siembra,
  preparacion,
  siembra,
} from '../../modelos'
import * as rules from '@/utils/validations'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'
import { finca_financiamiento } from '@/modelos'

export default {
  name: 'Cosecha',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    ModalEstablecimiento,
    SituacionDeDesastre,
  },
  extends: Form,
  data: () => {
    return {
      activeTab: 'ingreso',
      busquedaFin: false,
      errorSiembra: '',
      errorCosecha: '',
      grupos: [],
      //DRAGON ////////////////
      nuevocosecha: false,
      mensajeBusqueda: '',
      tipoMensaje: 'info',
      buscandoRegistro: false,
      errorFechaCosecha: '',
      errorFecha: '',
      mostrarobserva: false,
      filaVisibleIndex: null,
      indexEdicionconsecha: null,
      indexEdicion: null,
      mostrarFormularioEditable: true,
      //////////////////////////
      mostrarSiembra: true,
      mostrarCosecha: false,
      mostrarVenta: false,
      filaEdicion: {
        ID_CULTIVO: '',
        VARIEDAD: '',
        superficie_preparada: '',
        VOLUMEN_ANUAL_PRODUCCION: '',
        FECHA_ESTIMADA_COSECHA: '',
        SUPERFICIE_ACTUAL_SEMBRADA: '',
        CANTIDAD_SEMILLA: '',
        SEMILLA: '',
        errorFecha: '',
      },
      esta: 'A',
      idProductor: '',
      productorcito: '',
      idFinca: null,
      idParcela: null,
      fecha: null,
      lista_Ley: [],
      prueba: [],
      r: rules,
      validado: false,
      esNuevoRegistro: false,
      modal_registro_existe: false,
      modal_registro_existe_loading: false,
      registro_existente: {},
      sistemas: [],
      destinosActualizados: [],
      errorin: '',
      vobservacion: '',
      vpreparacionid_finca: '',
      vpreparacionid_parcela: '',
      vpreparacionfecha: '',
      vpreparacioncoa: '',
      vpreparacionley_de_beneficio: '',
      vpreparaciontipo_prima_seguro: '',
      vpreparacionfinanciamiento: '',
      vsiembratecnologias: [],
      vsiembraREALIZA_TRAZABILIDAD: '',
      alertar_superficie_mayor: '',
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: 'id_cultivo',
      ruta_registros: 'cosechas',
      ruta_registro: 'cosecha',
      nombre_registros_en_state: 'cosechas',
      nombre_registro_en_state: 'cosecha',
      dispatch_get_registro: 'getCosecha',
      dispatch_guardar_registro: 'guardarCosecha',
      siembraHeaders: [
        // DRAGON
        { text: 'Ver', value: 'Acción', align: 'center' },
        /////////
        { text: 'Cultivo *', value: 'id_cultivo', editable: true },
        { text: 'Variedad *', value: 'VARIEDAD', editable: true },
        {
          text: 'Superficie preparada para cultivo *',
          value: 'superficie_preparada',
          editable: true,
        },
        {
          text: 'Producción Esperada *',
          value: 'VOLUMEN_ANUAL_PRODUCCION',
          editable: true,
        },
        {
          text: 'Fecha Estimada a cosechar *',
          value: 'FECHA_ESTIMADA_COSECHA',
          editable: true,
        },
        {
          text: 'Hectareas Totales sembradas',
          value: 'SUPERFICIE_ACTUAL_SEMBRADA',
          editable: true,
        },
        {
          text: 'Cantidad de semilla sembrada',
          value: 'CANTIDAD_SEMILLA',
          editable: true,
        },
        { text: 'Tipo de Semilla', value: 'semilla', editable: true },
        { text: 'Eliminar', value: '', editable: true },
      ],
      siembraItems: [
        {
          ID_CULTIVO: '',
          VARIEDAD: '',
          superficie_preparada: '',
          VOLUMEN_ANUAL_PRODUCCION: '',
          FECHA_ESTIMADA_COSECHA: '',
          SUPERFICIE_ACTUAL_SEMBRADA: '',
          CANTIDAD_SEMILLA: '',
          SEMILLA: '',
          ID: '',
          id_p: '',
          ID_ENC: '',
        },
      ],
      cosecha: [
        {
          id_cultivo: '',
          variedad_cultivo: '',
          semilla: '',
          fecha: '',
          tiempo_produccion: '',
          superficie_cosechada: '',
          produccion: '',
          superficie_perdida: '',
          id: '',
          id_enc: '',
          id_finca: '',
          id_establecimiento: '',
          id_parcela: '',
          anio_agricola: '',
          ley_de_beneficio: '',
          coa: '',
          denominacion_varietal: '',
          produccion_anual_estimada: '',
          cantidad_vendida: '',
          precio_de_venta: '',
          sistemas: [],
          ingreso_anual: '',
          observacion: '',
          estatus: '',
          estatus_bono: '',
          fecha_preparacion: '',
        },
      ],

      cosechaHeaders: [
        { text: 'Cultivo *', value: 'id_cultivo', editable: true },
        { text: 'Variedad *', value: 'variedad_cultivo', editable: true },
        {
          text: 'Fecha de cosecha *',
          value: 'fecha',
          editable: true,
        },
        {
          text: 'Hectareas Totales cosechadas hasta el dia de hoy *',
          value: 'superficie_cosechada',
          editable: true,
        },
        {
          text: 'Producción total a la fecha *',
          value: 'produccion',
          editable: true,
        },
        { text: 'Rendimiento', value: 'rendimiento' },
        {
          text: 'Días de cosecha',
          value: 'tiempo_produccion',
          editable: true,
        },
        {
          text: 'Superficie Perdida (Ha)',
          value: 'superficie_perdida *',
          editable: true,
        },
        { text: 'Tipo de Semilla', value: 'semilla', editable: true },
        { text: 'Eliminar', value: '', editable: true },
      ],

      //AQUI ANI MODIFIQUE ///////

      gregistro: clona(formulario_cosecha),
      registro: clona(formulario_cosecha),
      preparacion: clona(formulario_preparacion),
      siembra: clona(formulario_siembra),
      aniosAgricolas: [],
      //registro_produccion: clona({}),
    }
  },
  created() {
    // Recibir los datos de la ruta
    const { id, id_productor, id_finca, id_parcela, fecha } = this.$route.params
    if (id_productor && id_finca && fecha) {
      // Asignar los datos a las variables locales
      this.idCosechaPrincipal = id || null
      this.idProductor = id_productor
      this.idFinca = id_finca
      this.idParcela = id_parcela !== 'null' ? id_parcela : null
      this.fecha = fecha
    }
  },
  computed: {
    ...mapState('listados', [
      'cultivo',
      'variedad_cultivo',
      'semilla',
      'tecnologia',
      'sino',
      'denominacion_varietal',
      'tipo_prima_seguro',
      'tipo_entidad_financiera',
      'sistema_produccion',
      'programa_gobierno',
      'anioagro',
    ]),
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getSumaDeExtensionEnPreparaciones',
      'getSumaDeExtensionEnCosechas',
      'finca',
      'existeRegistroEnState',
      'getMatchingRecords',
      'productor_actual',
    ]),

    ...mapGetters('listados', ['denominacionVarietalDeCultivo']),

    fechasSugeridas() {
      const preparaciones = this.$store.state.registros.preparaciones
      if (!this.vpreparacionid_finca || !this.vpreparacionid_parcela) {
        return []
      }
      // Extrae fechas únicas de registros locales con esa finca/parcela
      const fechas = Object.values(preparaciones)
        .filter(
          (p) =>
            p.id_finca === this.vpreparacionid_finca &&
            p.id_parcela === this.vpreparacionid_parcela
        )
        .map((p) => p.fecha)

      // Devuelve solo fechas únicas ordenadas (opcional)
      return [...new Set(fechas)].sort((a, b) => b.localeCompare(a))
    },
    sumaDeSuperficiesDeCosechas() {
      return parseInt(
        this.getSumaDeExtensionEnCosechas(
          this.registro.id,
          this.registro.id_finca, ///ESTA MAL CORREGIR NO EXISTE this.registro
          this.registro.coa,
          new Date(this.registro.fecha).getFullYear()
        )
      )
    },
    fincas() {
      // state.registros SI EXISTE y esta OK
      return toArray(this.$store.state.registros.fincas)
    },
    rubrosSeleccionados() {
      // Filtramos los rubros seleccionados y usamos los rubros completos con 'id' y 'descripcion'
      return this.cosecha
        .map((item) =>
          this.cultivo.find((cultivo) => cultivo.id === item.id_cultivo)
        )
        .filter((cultivo) => cultivo != null) // Filtrar los elementos nulos
    },
    // retorna cierto si existe al menos un financiamiento en el arreglo de financiamientos de la finca
    puedeRemoverFinanciamiento() {
      return this.finca.financiamientos.length >= 1
    },
    bien_financiado_repetido() {
      let rep = 0
      const cant_finan = this.finca.financiamientos.length
      for (const aseg of this.finca.financiamientos) {
        for (const aseg2 of this.finca.financiamientos) {
          if (
            aseg.activo === aseg2.activo &&
            aseg.tipo_entidad_financiera === aseg2.tipo_entidad_financiera
          ) {
            rep++
          }
        }
      }
      return rep > cant_finan
    },
    // retorna true si la produccion vendida excede la produccion producida
    cantidad_vendida_inversa() {
      let produccion = this.registro.produccion // CORREGIR NO EXISTE this.registro
      let vendido = this.registro.cantidad_vendida
      if (this.registro.unidad_produccion === 'lb') {
        produccion = produccion * this.lb_to_kg
      }
      if (this.registro.unidad_cantidad_vendida === 'lb') {
        vendido = vendido * this.lb_to_kg
      }
      return vendido > produccion
    },
    // AQUI DESPUES cálculo del rendimiento de la producción
    rendimiento() {
      // CORREGIR NO EXISTE this.registro
      if (this.registro.superficie_cosechada > 0) {
        return (
          (
            this.registro.produccion / this.registro.superficie_cosechada
          ).toFixed(2) || 0
        )
      } else {
        return 0
      }
    },
    /*  AQUI    invalidRelativeDate() {
       const preparacion =
         this.getMatchingRecords({
           recordName: 'preparaciones',
           matchValues: [
             { key: 'id_productor', value: this.registro.id_productor },
             { key: 'coa', value: this.registro.coa },
             { key: 'id_finca', value: this.registro.id_finca },
             { key: 'id_parcela', value: this.registro.id_parcela },
             { key: 'id_cultivo', value: this.registro.id_cultivo },
           ],
         })?.[0] ?? {}
       const siembra =
         this.getMatchingRecords({
           recordName: 'siembras',
           matchValues: [
             { key: 'id_productor', value: this.registro.id_productor },
             { key: 'COA', value: this.registro.coa },
             { key: 'ID_FINCA', value: this.registro.id_finca },
             { key: 'ID_PARCELA', value: this.registro.id_parcela },
             { key: 'ID_CULTIVO', value: this.registro.ID_CULTIVO },
           ],
         })?.[0] ?? {}
       const referenceRecord = {
         record: 'cosecha',
         date: this.registro.fecha,
       }
       const compareRecords = [
         { record: 'siembra', date: siembra.FECHA_SIEMBRA, cp: 'isAfter' },
         { record: 'preparacion', date: preparacion.fecha, cp: 'isAfter' },
       ].filter((v) => !!v)

       return isProductionDateValidComparedToRecords(
         referenceRecord,
         compareRecords
       )
     }, */
  },

  async mounted() {
    //Buscamos al productor actual cuando es un nuevo registro creado
    if (!this.idProductor) {
      this.productorcito = this.productor_actual
    }
    for (let i = 0; i < this.programa_gobierno.length; i++) {
      if (!this.programa_gobierno[i].indexOf('Ley')) {
        this.lista_Ley.push(this.programa_gobierno[i])
      }
      if (!this.programa_gobierno[i].indexOf('LEY')) {
        this.lista_Ley.push(this.programa_gobierno[i])
      }
    }

    this.$store.commit('ui/updateToolbar', 'Agricola')
    const id = this.obtenerIdDeRuta()
    //ASignamos al productor actual cuando estan creando uno nuevo
    //Si ya existe obtiene preparacion, siembra y registro(cosecha) y lo asigna al objeto preparacion, siembra y registro y despues llena
    // LLena los arreglos cosecha y siembraitems

    if (this.idProductor) {
      this.busquedaFin = true
      this.siembra = await this.obtenerSiembra()
      //console.log("SIEMBRA TA ", this.siembra)
      this.preparacion = await this.obtenerPreparacion()
      //console.log("PREPARACION TA ", this.preparacion)
      //El objeto de cosecha se llama registro y es el qque se guardara en la BD y es llenado por el arreglo cosecha de la pantalla
      //console.log("COSECHA TA ", this.registro)

      // AQUI this.registro SI VA THIS.REGISTRO    this.registro y destino
      this.registro = await this.obtenerUnRegistroONada()
      //console.log('registro', this.registro[0].id)
      // Verifica si el registro tiene datos y asigna los destinos correctamente
      // if (Array.isArray(this.registro) && this.registro.length > 0) {
      //   this.registro.destinos = this.registro.flatMap(reg => reg.destinos || [])
      // }
      // Si hay registros, extraemos todos los destinos de cada uno y eliminamos duplicados

      // Aplanamos los destinos de cada registro y eliminamos duplicados basándonos en el id_destino
      /* if (Array.isArray(this.registro) && this.registro.length > 0) {
        const allDestinos = this.registro.flatMap((reg) => reg.destinos || [])
        this.registro.destinos = allDestinos.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.id_destino === value.id_destino && t.rubro === value.rubro
            )
        )
      } */
      ///PARA DARLE REACTIVIDAD /////////////
      /* if (Array.isArray(this.registro) && this.registro.length > 0) {
          const allDestinos = this.registro.flatMap((reg) => reg.destinos || [])
          this.$set(this.registro, 'destinos', allDestinos) // <- $set para reactividad aunque registro sea un array
        } else if (this.registro && !Array.isArray(this.registro)) {
          // Si alguna vez es objeto, también garantizamos el campo
          if (!Array.isArray(this.registro.destinos)) {
            this.$set(this.registro, 'destinos', [])
          }
        } */
      // LO ANTERIOR SE REEMPLAZO POR ESTO /////////////////////////
      /////  CREA registro.destinos  ///////////////////////////////
      /*   if (Array.isArray(this.registro) && this.registro.length > 0) {
       //Combina todos los destinos de todos ls registros en un solo array
        const allDestinos = this.registro.flatMap((reg) => reg.destinos || [])
        // Asigna directamente a this.registro.destinos sin filtrar
        this.registro.destinos = allDestinos
      }  */
      //////////////////////////////////////////////////////////////
      this.cosecha = []
      if (this.registro.producciones && this.registro.producciones.length > 0) {
        this.$set(
          this,
          'cosecha',
          this.registro.producciones.map((co) => ({
            id: co.id || '',
            id_enc: co.id_enc || '',
            idprin: co.idprin || '',
            id_finca: co.id_finca || '',
            id_parcela: co.id_parcela || '',
            id_establecimiento: co.id_establecimiento || '',
            fecha: co.fecha || '',
            id_cultivo: co.id_cultivo || '',
            variedad_cultivo: co.variedad_cultivo || '',
            semilla: co.semilla || '',
            tiempo_produccion: co.tiempo_produccion || 0,
            superficie_cosechada: co.superficie_cosechada || 0,
            produccion: co.produccion || 0,
            superficie_perdida: co.superficie_perdida || 0,
            produccion_anual_estimada: co.produccion_anual_estimada || 0,
            cantidad_vendida: co.cantidad_vendida || 0,
            precio_de_venta: co.precio_de_venta || 0,
            ingreso_anual: co.ingreso_anual || 0,
            //ley_de_beneficio: co.ley_de_beneficio || '',
            //observacion: co.observacion || '',
            coa: co.coa || '',
            estatus: co.estatus || 'A',
            //destinos: co.destinos || [],
            created_at: new Date().getTime() / 1000,
            denominacion_varietal: co.denominacion_varietal || '',
            estatus_bono: co.estatus_bono || '',
            fecha_preparacion: co.fecha_preparacion || '',
          }))
        )
      }
      ///////////////////////////////////////////////////////////////////

      // siembraItems es el arreglo de la pantalla que es llenado por los objetos preparacion y despues siembra.
      //ESTO NO ES CORRECTO: siembraItems = this.preparacion ///
      // **Limpia siembraItems antes de llenarlo para evitar duplicados**
      this.siembraItems = []

      if (this.siembra && this.siembra.length) {
        //recorremos el arreglo de objetos de this.siembra
        for (let i = 0; i < this.siembra.length; i++) {
          let si = this.siembra[i]
          this.siembraItems.push({
            ID_CULTIVO: si.ID_CULTIVO || '',
            VARIEDAD: si.VARIEDAD || '',
            VOLUMEN_ANUAL_PRODUCCION: si.VOLUMEN_ANUAL_PRODUCCION || 0,
            FECHA_ESTIMADA_COSECHA: si.FECHA_ESTIMADA_COSECHA || '',
            SUPERFICIE_ACTUAL_SEMBRADA: si.SUPERFICIE_ACTUAL_SEMBRADA || '',
            CANTIDAD_SEMILLA: si.CANTIDAD_SEMILLA || '',
            SEMILLA: si.SEMILLA || '',
            ID: si.ID || '',
            ID_ENC: si.ID_ENC || null,
            //tecnologias: si.tecnologias,
            //REALIZA_TRAZABILIDAD: si.REALIZA_TRAZABILIDAD,
          })
        }
        this.vsiembratecnologias = this.siembra[0].tecnologias || []
        this.vsiembraREALIZA_TRAZABILIDAD =
          this.siembra[0]?.REALIZA_TRAZABILIDAD ?? null
        /*  this.siembra[0].REALIZA_TRAZABILIDAD !== null
              ? Number(this.siembra[0].REALIZA_TRAZABILIDAD)
              : null */
      }

      //console.log("SIEMBRAITEMS TA ", this.siembraItems)
      // recorre el objeto siembra para llenar la parte de siembra del arreglo de siembraItems
      this.asignarSuperficiePreparada()
      //asignamos los datos de this.cosecha a

      //this.vobservacion = this.registro.observacion
      //this.registro.destinos = this.cosecha.destinos
      //this.registro.estatus = 'A'
      //this.vpreparacionley_de_beneficio = this.cosecha[0].ley_de_beneficio || ''
      //console.log("TABLA COSECHA TA ", this.cosecha)
      //agregamos registro nuevos abiertos
      /*  this.addSiembraItems()
      this.addCosecha() */
    } else {
      //console.log('G4')
      this.idProductor = this.productorcito
      this.esNuevoRegistro = true // Si no hay productor, es un nuevo registro
      this.busquedaFin = false
      //limpiam/*  */os array de siembra y cosecha
      this.siembraItems = []
      //this.cosecha = []
      //agregamos registro nuevos abiertos
      /* this.addSiembraItems()
      this.addCosecha()
     */
    }
    this.calculaAniosAgricolas()
    //this.setDefaultAnioAgricola()
  },

  watch: {
    '$route.params': {
      immediate: true,
      handler(nuevo) {
        const { id, id_productor, id_finca, id_parcela, fecha } = nuevo
        this.idCosechaPrincipal = id || null
        if (id_productor && id_finca && fecha) {
          this.idProductor = id_productor
          this.idFinca = id_finca
          this.idParcela = id_parcela !== 'null' ? id_parcela : null
          this.fecha = fecha
        }
      },
    },

    /*  '$route.params': {
    immediate: true,
    deep: true,
    handler(nuevaRuta) {
      this.actualizarDesdeRuta(nuevaRuta)
    }
   } */
    /*  'registro.superficie_cosechada'() {
      this.alertSurfaceOverflow()
    }, */
    /*  'registro.destinos': {
      deep: true,
      handler(newDestinos) {
        console.log('Datos actualizados:', newDestinos)
      },
    }, */

    /*  "registro.destinos": {
      handler(newDestinos) {
        if (Array.isArray(newDestinos)) {
          this.cosecha.forEach((item) => {
            item.destinos = [...newDestinos]
          })
        }
      },
      deep: true,
    }, */

    siembraItems: {
      handler(nuevoValor) {
        if (nuevoValor.length > 0) {
          // Tomamos el primer elemento de siembraItems como referencia
          let primerItem = nuevoValor[0]

          // Llenamos el objeto preparacion con los valores de siembraItems
          this.preparacion.id_finca = primerItem.id_finca || null
          this.preparacion.id_parcela = primerItem.id_parcela || null
          this.preparacion.fecha = primerItem.fecha || null
          this.preparacion.coa = primerItem.coa || null
          this.preparacion.ley_de_beneficio =
            primerItem.ley_de_beneficio || null
          this.preparacion.tipo_entidad_financiera =
            primerItem.tipo_entidad_financiera || null
        }
      },
      deep: true,
    },
    siembra: {
      handler(nuevoValor) {
        if (nuevoValor.length > 0) {
          // Tomamos el primer elemento de siembra como referencia
          let primerItem = nuevoValor[0]

          // Llenamos el objeto siembra con los valores obtenidos
          this.siembra.tecnologias = primerItem.tecnologias || []
          this.siembra.REALIZA_TRAZABILIDAD =
            primerItem.REALIZA_TRAZABILIDAD || null
          this.siembra.tipo_prima_seguro = primerItem.tipo_prima_seguro || null
        }
      },
      deep: true, // Observa cambios en los objetos dentro del array
    },
    ////////////////////////////////////////////////////////////////////////////////////
    // ESTO VA PARA TENER ACTUALIZADO A LOS CAMPOS DE HTML ARRIBA //////////////////////
    preparacion: {
      handler(nuevoValor) {
        if (nuevoValor.length > 0) {
          this.vpreparacionid_finca = nuevoValor[0].id_finca || null
          this.vpreparacionid_parcela = nuevoValor[0].id_parcela || null
          this.vpreparacionfecha = nuevoValor[0].fecha || null
          this.vpreparacioncoa = nuevoValor[0].coa || null
          this.vpreparacionley_de_beneficio =
            nuevoValor[0].ley_de_beneficio || null
          this.vpreparaciontipo_prima_seguro =
            nuevoValor[0].tipo_prima_seguro || null
          this.vpreparacionfinanciamiento = nuevoValor[0].financiamiento || null
        }
      },
      deep: true,
    },
    siembra: {
      handler(nuevoValr) {
        if (nuevoValr.length > 0) {
          // Llenamos el arreglo de objetos siembra con los valores obtenidos
          this.vsiembratecnologias = nuevoValr[0].tecnologias || []
          this.vsiembraREALIZA_TRAZABILIDAD =
            nuevoValr[0].REALIZA_TRAZABILIDAD !== null
              ? Number(nuevoValr[0].REALIZA_TRAZABILIDAD)
              : null
        }
      },
      deep: true, // Observa cambios en los objetos dentro del array
    },

    // este es el objeto de cosecha //////////////
  },

  methods: {
    async handleBack() {
      if (this.mostrarRegistro()) {
        const confirmacion = confirm('¿Desea guardar los datos antes de salir?')
        if (confirmacion) {
          try {
            await this.guardarYContinuar()
          } catch (e) {
            console.error('Error al guardar:', e)
          }
        } else {
          this.$router.go(-1)
        }
      } else {
        this.$router.go(-1)
      }
    },
    mostrarRegistro() {
      return this.idProductor && this.idFinca && this.idParcela && this.fecha
    },
    SiembraChange() {
      this.debounceBuscarRegistroExistente()
      this.verificarSiembraExistente()
    },
    CosechaChange() {
      this.debounceBuscarRegistroExistente()
      this.verificarCosechaExistente()
    },
    async verificarSiembraExistente() {
      await this.$nextTick()

      // Limpiar error previo
      this.errorSiembra = null

      const entrada = this.siembraItems[this.indexEdicion]
      const id_productor = this.productor_actual
      const id_finca = this.vpreparacionid_finca
      const id_parcela = this.vpreparacionid_parcela
      const fecha_siembra = this.vpreparacionfecha

      const { ID_CULTIVO, VARIEDAD, SEMILLA } = entrada

      // Verificación de campos obligatorios
      if (
        !id_productor ||
        !id_finca ||
        !id_parcela ||
        !fecha_siembra ||
        !ID_CULTIVO ||
        !VARIEDAD ||
        !SEMILLA
      ) {
        return
      }

      // Verificar siembra existente locales
      const siembraLocalExistente = this.siembraItems.find((item, index) => {
        // No comparar consigo mismo
        if (index === this.indexEdicion) return false
        return (
          item.ID_CULTIVO === ID_CULTIVO &&
          item.VARIEDAD === VARIEDAD &&
          item.SEMILLA === SEMILLA &&
          this.vpreparacionid_finca === id_finca &&
          this.vpreparacionid_parcela === id_parcela &&
          this.vpreparacionfecha === fecha_siembra
        )
      })

      if (siembraLocalExistente) {
        this.errorSiembra = 'Esta siembra ya existe.'
        return // No necesita buscar en BD
      }

      // 2. BÚSQUEDA EN BASE DE DATOS
      const payload = {
        id_productor,
        id_finca: id_finca,
        id_parcela: id_parcela,
        fecha: fecha_siembra,
        id_cultivo: ID_CULTIVO,
        variedad: VARIEDAD,
        semilla: SEMILLA,
      }

      try {
        const res = await this.$store.dispatch(
          'registros/listarSiembras',
          payload
        )
        // FILTRAR REGISTROS DE BD con todos los campos exactos
        //const siembra = res?.data?.[0]
        const siembra = res?.data?.find(
          (s) =>
            s.ID_CULTIVO === ID_CULTIVO &&
            s.VARIEDAD === VARIEDAD &&
            s.SEMILLA === SEMILLA &&
            s.ID_FINCA === id_finca &&
            s.ID_PARCELA === id_parcela &&
            s.FECHA_SIEMBRA === fecha_siembra
        )

        if (siembra) {
          this.errorSiembra = 'Esta siembra ya existe.'
        } else {
          this.errorSiembra = null
        }
      } catch (error) {
        this.errorSiembra = 'Error al consultar siembras'
      }
    },
    async verificarCosechaExistente() {
      await this.$nextTick()

      this.errorCosecha = null

      const entrada = this.cosecha[this.indexEdicionconsecha]

      if (!entrada) {
        return
      }
      //en cosecha la fecha vpreparacionfecha se guarda como fecha_preparacion
      const id_productor = this.productor_actual
      const id_finca = this.vpreparacionid_finca
      const id_parcela = this.vpreparacionid_parcela
      const fecha_preparacion = this.vpreparacionfecha

      const { id_cultivo, variedad_cultivo, semilla, fecha } = entrada

      if (
        !id_productor ||
        !id_finca ||
        !id_parcela ||
        !fecha_preparacion ||
        !id_cultivo ||
        !variedad_cultivo ||
        !semilla ||
        !fecha
      ) {
        return
      }

      const cosechaLocalExistente = this.cosecha.find((item, index) => {
        if (index === this.indexEdicionconsecha) return false

        return (
          this.vpreparacionid_finca === id_finca &&
          this.vpreparacionid_parcela === id_parcela &&
          this.vpreparacionfecha === fecha_preparacion &&
          item.id_cultivo === id_cultivo &&
          item.variedad_cultivo === variedad_cultivo &&
          item.fecha === fecha &&
          item.semilla === semilla
        )
      })

      if (cosechaLocalExistente) {
        this.errorCosecha = 'Esta cosecha ya existe en el registro actual'
        return
      }

      const payload = {
        id_productor,
        id_finca: id_finca,
        id_parcela: id_parcela,
        fecha_preparacion: fecha_preparacion,
        id_cultivo: id_cultivo,
        variedad_cultivo: variedad_cultivo,
        fecha: fecha,
        semilla: semilla,
      }

      try {
        const res = await this.$store.dispatch(
          'registros/listarCosechas',
          payload
        )
        const cosechaEncontrada = res?.data?.find(
          (s) =>
            s.id_cultivo === id_cultivo &&
            s.variedad_cultivo === variedad_cultivo &&
            s.semilla === semilla &&
            s.id_parcela === id_parcela &&
            s.fecha_preparacion === fecha_preparacion &&
            s.fecha === fecha
        )

        if (cosechaEncontrada) {
          this.errorCosecha = 'Esta cosecha ya existe.'
        }
      } catch (error) {
        this.errorCosecha = 'Error al consultar cosechas'
      }
    },
    registroNoEncontrado() {
      this.mensajeBusqueda =
        'Excelente, añadiendo uno nuevo, continua llenando y recuerda Guardar...'
      this.tipoMensaje = 'info'
      this.nuevocosecha = true
      this.busquedaFin = true
    },

    onFincaChange() {
      if (this.busquedaFin) return
      this.debounceBuscarRegistroExistente()
      this.debounceBuscarRegistroPorCriterios()
    },

    onParcelaChange() {
      if (this.busquedaFin) return
      this.debounceBuscarRegistroExistente()
      this.debounceBuscarRegistroPorCriterios()
    },

    onFechaChange() {
      const camposValidos =
        this.$refs.fincaSelect.validate() && this.$refs.fechaInicio.validate()

      if (!camposValidos) {
        this.$store.commit('ui/setSnack', {
          text: 'Debe llenar Finca, Parcela y Fecha antes de continuar',
          color: 'error',
        })
        return
      }

      if (this.busquedaFin) return
      this.validarFecha()
      this.debounceBuscarRegistroPorCriterios()
    },

    async onLupaChange() {
      // 1) Forzar que el texto escrito quede en el modelo antes de validar
      const cb = this.$refs.fechaInicio
      if (
        cb &&
        cb.internalSearch != null &&
        cb.internalSearch !== this.vpreparacionfecha
      ) {
        this.vpreparacionfecha = cb.internalSearch.trim()
      }
      await this.$nextTick()

      const camposValidos =
        this.$refs.fincaSelect.validate() &&
        this.$refs.parcelaSelect.validate() &&
        this.$refs.fechaInicio.validate()

      if (!camposValidos) {
        this.$store.commit('ui/setSnack', {
          text: 'Debe llenar Finca, Parcela y Fecha antes de continuar',
          color: 'error',
        })
        return
      }

      if (!this.validarFecha()) {
        return
      }

      if (this.busquedaFin) return
      // Ejecutar función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    debounceBuscarRegistroPorCriterios: debounce(async function () {
      await this.buscarRegistroPorCriterios()
    }, 1000),

    async buscarRegistroPorCriterios() {
      if (this.busquedaFin) {
        return
      }

      if (!this.vpreparacionid_finca || !this.vpreparacionfecha) {
        // !this.productor_actual
        this.limpiarMensaje()
        return
      }
      this.buscandoRegistro = true
      this.limpiarMensaje()
      try {
        // Buscar registro existente
        const registroExistente = await this.buscarRegistroLocal()
        if (registroExistente) {
          await this.traerRegistroYNavegar(registroExistente)
        } else {
          this.registroNoEncontrado()
        }
      } catch (error) {
        this.registroNoEncontrado()
      } finally {
        this.buscandoRegistro = false
        this.busquedaFin = true
      }
    },

    async buscarRegistroLocal() {
      try {
        if (this.idProductor) {
          const response = await this.$store.dispatch(
            'registros/listarAgricolas',
            {
              id_productor: this.idProductor,
              id_finca: this.vpreparacionid_finca,
              id_parcela: this.vpreparacionid_parcela,
              fecha: this.vpreparacionfecha,
              fechaproddesde: '',
              fechaprodhasta: '',
            }
          )

          // AGREGAR ESTA PARTE para encontrar el registro específico:
          if (response && response.data && Array.isArray(response.data)) {
            return response.data.find(
              (registro) =>
                registro.id_finca == this.vpreparacionid_finca &&
                registro.id_parcela == this.vpreparacionid_parcela &&
                registro.fecha == this.vpreparacionfecha
            )
          }
        }
        return null
      } catch (e) {
        return null
      }
    },

    async traerRegistroYNavegar(registro) {
      const { idCosechaPrincipal, id_productor, id_finca, id_parcela, fecha } =
        registro
      this.$router.push(
        `/ru/cosecha/${idCosechaPrincipal}/${id_productor}/${id_finca}/${
          id_parcela || 'null'
        }/${fecha}`
      )
      this.busquedaFin = true
      await this.inicializarFormulario()
    },

    mostrarMensaje(mensaje, tipo) {
      this.mensajeBusqueda = mensaje
      this.tipoMensaje = tipo
    },

    limpiarMensaje() {
      this.mensajeBusqueda = ''
      this.tipoMensaje = 'info'
    },
    async inicializarFormulario() {
      //const id = this.obtenerIdDeRuta()
      const { id, id_productor, id_finca, id_parcela, fecha } =
        this.$route.params
      this.idCosechaPrincipal = id
      this.idProductor = id_productor
      this.idFinca = id_finca
      this.idParcela = id_parcela !== 'null' ? id_parcela : null
      this.fecha = fecha
      if (!this.idProductor) {
        this.productorcito = this.productor_actual
      }
      // Llenar lista_Ley
      for (let i = 0; i < this.programa_gobierno.length; i++) {
        if (!this.programa_gobierno[i].indexOf('Ley')) {
          this.lista_Ley.push(this.programa_gobierno[i])
        }
        if (!this.programa_gobierno[i].indexOf('LEY')) {
          this.lista_Ley.push(this.programa_gobierno[i])
        }
      }

      if (this.idProductor) {
        this.siembra = await this.obtenerSiembra()
        this.preparacion = await this.obtenerPreparacion()
        this.registro = await this.obtenerUnRegistroONada()
        ///PARA DARLE REACTIVIDAD /////////////
        // if (Array.isArray(this.registro) && this.registro.length > 0) {
        //   const allDestinos = this.registro.flatMap((reg) => reg.destinos || [])
        //   this.$set(this.registro, 'destinos', allDestinos) // <- $set para reactividad aunque registro sea un array
        // } else if (this.registro && !Array.isArray(this.registro)) {
        //   // Si alguna vez es objeto, también garantizamos el campo
        //   if (!Array.isArray(this.registro.destinos)) {
        //     this.$set(this.registro, 'destinos', [])
        //   }
        // }
        /*   if (Array.isArray(this.registro) && this.registro.length > 0) {
          const allDestinos = this.registro.flatMap((reg) => reg.destinos || [])
          this.registro.destinos = allDestinos.filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.id_destino === value.id_destino && t.rubro === value.rubro
              )
          )
        } */

        // LO ANTERIOR SE REEMPLAZO POR ESTO - crea registro.destinos   /////////////////////////
        /*  if (Array.isArray(this.registro) && this.registro.length > 0) {
          const allDestinos = this.registro.flatMap((reg) => reg.destinos || [])
          this.registro.destinos = allDestinos
        }  */
        ///////////////////////////////////////////////////////////////
        this.cosecha = []
        //ahora cosechas es producciones dentro de registros
        if (
          this.registro.producciones &&
          this.registro.producciones.length > 0
        ) {
          this.$set(
            this,
            'cosecha',
            this.registro.producciones.map((co) => ({
              id: co.id || '',
              id_enc: co.id_enc || '',
              idprin: co.idprin || '',
              id_finca: co.id_finca || '',
              id_parcela: co.id_parcela || '',
              id_establecimiento: co.id_establecimiento || '',
              fecha: co.fecha || '',
              id_cultivo: co.id_cultivo || '',
              variedad_cultivo: co.variedad_cultivo || '',
              semilla: co.semilla || '',
              tiempo_produccion: co.tiempo_produccion || 0,
              superficie_cosechada: co.superficie_cosechada || 0,
              produccion: co.produccion || 0,
              superficie_perdida: co.superficie_perdida || 0,
              produccion_anual_estimada: co.produccion_anual_estimada || 0,
              cantidad_vendida: co.cantidad_vendida || 0,
              precio_de_venta: co.precio_de_venta || 0,
              ingreso_anual: co.ingreso_anual || 0,
              //ley_de_beneficio: co.ley_de_beneficio || '',
              //observacion: co.observacion || '',
              coa: co.coa || '',
              estatus: co.estatus || 'A',
              //destinos: co.destinos || [],
              created_at: new Date().getTime() / 1000,
              denominacion_varietal: co.denominacion_varietal || '',
              estatus_bono: co.estatus_bono || '',
              fecha_preparacion: co.fecha_preparacion || '',
            }))
          )
        }

        this.siembraItems = []

        if (this.siembra && this.siembra.length) {
          //recorremos el arreglo de objetos de this.siembra
          for (let i = 0; i < this.siembra.length; i++) {
            let si = this.siembra[i]
            this.siembraItems.push({
              ID_CULTIVO: si.ID_CULTIVO || '',
              VARIEDAD: si.VARIEDAD || '',
              VOLUMEN_ANUAL_PRODUCCION: si.VOLUMEN_ANUAL_PRODUCCION || 0,
              FECHA_ESTIMADA_COSECHA: si.FECHA_ESTIMADA_COSECHA || '',
              SUPERFICIE_ACTUAL_SEMBRADA: si.SUPERFICIE_ACTUAL_SEMBRADA || '',
              CANTIDAD_SEMILLA: si.CANTIDAD_SEMILLA || '',
              SEMILLA: si.SEMILLA || '',
              ID: si.ID || '',
              ID_ENC: si.ID_ENC,
              //tecnologias: si.tecnologias,
              //REALIZA_TRAZABILIDAD: si.REALIZA_TRAZABILIDAD,
            })
          }
          this.vsiembratecnologias = this.siembra[0].tecnologias || []
          this.vsiembraREALIZA_TRAZABILIDAD =
            this.siembra[0]?.REALIZA_TRAZABILIDAD ?? null
          /*  this.siembra[0].REALIZA_TRAZABILIDAD !== null
              ? Number(this.siembra[0].REALIZA_TRAZABILIDAD)
              : null */
        }

        this.asignarSuperficiePreparada()
        //this.vobservacion = this.registro.observacion
        //this.registro.estatus = 'A'
      }
    },

    /*  manejarSiembra() {
    this.mostrarSiembra = true
    this.mostrarCosecha = false
    this.mostrarVenta = false
    const formularioVacio = this.siembraItems.find(p =>
    !p.ID_CULTIVO || p.ID_CULTIVO === '' || p.ID_CULTIVO === null || // Valida ID_CULTIVO
    !p.VARIEDAD || p.VARIEDAD === '' || p.VARIEDAD === null || //  validación para VARIEDAD
    !p.SUPERFICIE_ACTUAL_SEMBRADA || p.SUPERFICIE_ACTUAL_SEMBRADA === '' || p.SUPERFICIE_ACTUAL_SEMBRADA === null || // Nueva validación para SUPERFICIE_ACTUAL_SEMBRADA
    !p.CANTIDAD_SEMILLA || p.CANTIDAD_SEMILLA === '' || p.CANTIDAD_SEMILLA === null // Nueva validación para CANTIDAD_SEMILLA
  );
    
    if (formularioVacio) {
      this.indexEdicion = this.siembraItems.indexOf(formularioVacio)
    }
    else {
    this.addSiembraItems();
    this.indexEdicion = this.siembraItems.length - 1;
    }
  }, */
    /*  manejarCosecha() {
    this.mostrarSiembra = false
    this.mostrarCosecha = true
    this.mostrarVenta = false

   const formularioVacio = this.cosecha.find(p =>
    !p.id_cultivo || p.id_cultivo === '' || p.id_cultivo === null || // Valida ID_CULTIVO
    !p.variedad_cultivo || p.variedad_cultivo === '' || p.variedad_cultivo === null || // Valida variedad_cultivo
    !p.fecha || p.fecha === '' || p.fecha === null // Valida fecha
   );
    
    if (formularioVacio) {
      this.indexEdicionconsecha = this.cosecha.indexOf(formularioVacio)
    }
    else {
    this.addCosecha();
    this.indexEdicindexEdicionconsechaion = this.cosecha.length - 1;
    }
  }, */

    obtenerNombreCultivo(idCultivo) {
      if (!idCultivo) return ''
      const cultivoEncontrado = this.cultivo.find((c) => c.id === idCultivo)
      return cultivoEncontrado ? cultivoEncontrado.descripcion : ''
    },
    obtenerNombreCultivocosecha(idCultivo) {
      if (!idCultivo) return ''
      const cultivoEncontrado = this.cultivo.find((c) => c.id === idCultivo)
      return cultivoEncontrado ? cultivoEncontrado.descripcion : ''
    },
    //////////   DRAGON ///////////////
    mostrarFormularioEdicion(index) {
      const item = this.siembraItems[index]
      // Hacemos una copia editable para no afectar en tiempo real la tabla
      this.filaEdicion = { ...item }
      this.filaVisibleIndex = index
      this.mostrarFormularioEditable = true
    },
    esSiembraValida(item) {
      return (
        item.ID_CULTIVO ||
        item.VARIEDAD ||
        item.VOLUMEN_ANUAL_PRODUCCION ||
        item.FECHA_ESTIMADA_COSECHA ||
        item.SUPERFICIE_ACTUAL_SEMBRADA ||
        item.CANTIDAD_SEMILLA
      )
    },
    // Función para verificar si un item de cosecha tiene datos
    esCosechaValida(fila) {
      return (
        fila.id_cultivo ||
        fila.variedad_cultivo ||
        fila.fecha ||
        fila.superficie_cosechada ||
        fila.produccion ||
        fila.cantidad_vendida
      )
    },
    /*manejarVenta() {
    this.mostrarCosecha = false
    this.mostrarSiembra = false
    this.mostrarVenta = true
      const formularioVacio = this.registro.destinos.find(p => 
      !p.rubro || 
      p.rubro === '' || 
      p.rubro === null
    )
    
    if (formularioVacio) {
      this.indexEdicionVenta = this.registro.destinos.indexOf(formularioVacio)
    } 
  },*/

    guardarEntrada() {
      // Validar que no hay errores antes de guardar
      if (this.errorSiembra) {
        return
      }
      if (!this.$refs.form.validate()) {
        this.$store.commit('ui/setSnack', {
          text: 'Verifique los elementos en rojo',
          color: 'error',
        })
        return ''
      }
      this.indexEdicion = null
    },

    guardarCosecha() {
      if (this.errorCosecha) {
        return
      }
      if (!this.$refs.form.validate()) {
        this.$store.commit('ui/setSnack', {
          text: 'Verifique los elementos en rojo',
          color: 'error',
        })
        return ''
      }
      this.indexEdicionconsecha = null
    },
    ocultarFormulario() {
      // DRAGON Guarda los cambios en la tabla original
      if (this.filaVisibleIndex !== null) {
        this.$set(this.registro.producciones, this.filaVisibleIndex, {
          ...this.filaEdicion,
        })
      }
      this.filaVisibleIndex = null
      this.mostrarFormularioEditable = false
      this.filaEdicion = null
    },

    //////////////////////////////////////////////

    pmostrarSiembra() {
      this.mostrarCosecha = false
      this.mostrarVenta = false
      this.mostrarSiembra = true
      this.activeTab = 'ingreso'
    },
    pmostrarCosecha() {
      this.mostrarCosecha = true
      this.mostrarVenta = false
      this.mostrarSiembra = false
      this.activeTab = 'engorde'
    },
    pmostrarVenta() {
      this.mostrarCosecha = false
      this.mostrarVenta = true
      this.mostrarSiembra = false
      this.activeTab = 'venta'
    },
    editarProduccion(index) {
      this.indexEdicion = index
    },
    editarCosecha(index) {
      this.indexEdicionconsecha = index
    },
    calcularRendimiento(item) {
      if (!item) return '0'
      const superficie = parseFloat(item.superficie_cosechada)
      const produccion = parseFloat(item.produccion)
      if (!superficie || superficie === 0 || isNaN(produccion)) return '0'
      return (produccion / superficie).toFixed(2)
    },
    rendimientoMayorA1(item) {
      if (!item) return false
      const superficie = parseFloat(item.superficie_cosechada)
      const produccion = parseFloat(item.produccion)
      return superficie > 0 && produccion / superficie > 1
    },
    //////////////////////////// AQUI   CREO QUE NO VA /////////////////////////////////////////////////
    /* addPreparacion() {
      this.preparacion.push({
  id_finca: '',
  id_establecimiento: '',
  id_parcela: '',
  coa: '',
  fecha: '',
  anio_agricola: '',
  id_cultivo: '',
  variedad_cultivo: '',
  semilla: '',
  denominacion_varietal: '',
  superficie_preparada: '',
  prima_de_seguro: '',
  tipo_prima_seguro: '',
  financiamiento: '0',
  ley_de_beneficio: '',
  estatus: '',
  observacion: '',
      })
    },
    deletePreparacion(index) {
      this.preparacion.splice(index, 1)
    },
    addSiembra() {
      this.siembra.push({
  ID_FINCA: '',
  ID_ESTABLECIMIENTO: '',
  ID_PARCELA: '',
  COA: '',
  ID_CULTIVO: '',
  VARIEDAD: '',
  SEMILLA: '',
  DENOMINACION_VARIETAL: '',
  ID_PROVINCIA: '',
  ID_DISTRITO: '',
  ID_CORREGIMIENTO: '',
  ID_POBLADO: '',
  LATITUD: '',
  LONGITUD: '',
  SUPERFICIE_ACTUAL_SEMBRADA: '',
  SUPERFICIE_ADICIONAL_PROYECTADA: '',
  VOLUMEN_ANUAL_PRODUCCION: '',
  CANTIDAD_SEMILLA: '',
  FECHA_ESTIMADA_COSECHA: '',
  PRIMA_SEGURO_ESTATAL: '',
  PRIMA_SEGURO_PRIVADO: '',
  FINANCIAMIENTO_COOPERATIVA: '',
  FINANCIAMIENTO_ESTATAL: '',
  AUTO_FINANCIAMIENTO: '',
  OTRO_TIPO_FINANCIAMIENTO: '',
  REALIZA_TRAZABILIDAD: '',
  FECHA_SIEMBRA: '',
  ANIO_AGRICOLA: '',
  ley_de_beneficio: '',
  tecnologias: [],
  estatus: '',
  observacion: '',
      })
    },
    deleteSiembra(index) {
      this.siembra.splice(index, 1)
    }, */
    ///////////////////////////////////////////////////////////////////////////////////////////
    addSiembraItems() {
      const nuevoItem = {
        ID_CULTIVO: '',
        VARIEDAD: '_NO',
        superficie_preparada: '',
        VOLUMEN_ANUAL_PRODUCCION: '',
        FECHA_ESTIMADA_COSECHA: '',
        SUPERFICIE_ACTUAL_SEMBRADA: '',
        CANTIDAD_SEMILLA: '',
        SEMILLA: '_NO',
        ID: '',
        id_p: '',
        ID_ENC: '',
      }
      this.siembraItems.unshift(nuevoItem) // Agrega al INICIO en lugar de push
      this.indexEdicion = 0 // Automáticamente entra en modo edición
      this.$nextTick(() => {
        if (this.$refs.tipoGanadoSelect && this.$refs.tipoGanadoSelect.focus) {
          this.$refs.tipoGanadoSelect.focus()
        }
      })
    },

    deleteSiembraItems(index) {
      /*  console.log('Índice a eliminar:', index)
      console.log('indexEdicion antes:', this.indexEdicion)
      console.log('Antes de eliminar:', this.siembraItems.length) */

      // Crear nuevo array sin el elemento
      const newSiembraItems = [...this.siembraItems]
      newSiembraItems.splice(index, 1)

      // Actualizar usando Vue.set para mantener reactividad
      this.$set(this, 'siembraItems', newSiembraItems)
      this.$set(this, 'siembra', [...newSiembraItems])

      //console.log('Después de eliminar:', this.siembraItems.length)

      this.indexEdicion = null

      this.$nextTick(() => {
        console.log('indexEdicion después:', this.indexEdicion)
        console.log('SiembraItems actualizados:', this.siembraItems)
        console.log('Siembra para guardar:', this.siembra)
      })
    },
    deleteCosecha(index) {
      this.cosecha.splice(index, 1)
      if (this.indexEdicionconsecha === index) {
        this.indexEdicionconsecha = null
      } else if (this.indexEdicionconsecha > index) {
        this.indexEdicionconsecha--
      }
    },

    addCosecha() {
      // cosecha es la tabla de la pantalla que es un ARREGLO, el Objeto se llama registro
      const nueviCosecha = {
        id_cultivo: '',
        variedad_cultivo: '_NO',
        trazabilidad: '',
        fecha: '',
        tiempo_produccion: '',
        superficie_cosechada: '',
        produccion: '',
        superficie_perdida: '',
        id: '',
        semilla: '_NO',
        id_enc: '',
        id_finca: '',
        id_establecimiento: '',
        id_parcela: '',
        anio_agricola: '',
        ley_de_beneficio: '',
        coa: '',
        denominacion_varietal: '',
        produccion_anual_estimada: '',
        cantidad_vendida: '',
        precio_de_venta: '',
        sistemas: [],
        ingreso_anual: '',
        observacion: '',
        estatus: '',
        estatus_bono: '',
        fecha_preparacion: '',
        //destinos: [],
      }
      this.cosecha.unshift(nueviCosecha) // Agrega al INICIO en lugar de push
      this.indexEdicionconsecha = 0 // Automáticamente entra en modo edición
      this.$nextTick(() => {
        if (
          this.$refs.tipoGanadoCosecha &&
          this.$refs.tipoGanadoCosecha.focus
        ) {
          this.$refs.tipoGanadoCosecha.focus()
        }
      })
    },

    asignarSuperficiePreparada() {
      //recorre el objeto preparacion para llenar el ARREGLO siembraItems justo donde coinciden las LLAVES
      this.preparacion.forEach((pre) => {
        this.siembraItems.forEach((item) => {
          if (
            pre.id_cultivo === item.ID_CULTIVO &&
            pre.variedad_cultivo === item.VARIEDAD &&
            pre.semilla === item.SEMILLA
          ) {
            this.$set(item, 'superficie_preparada', pre.superficie_preparada)
            this.$set(item, 'id_p', pre.id || '')
            //this.$set(item, 'ID_ENC', );
            this.$set(item, 'financiamiento', pre.financiamiento || '')
          }
        })
      })
    },
    validarFecha() {
      // Tu lógica de validación para la fecha de inicio
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      const fecha = this.vpreparacionfecha

      if (!regexFecha.test(this.vpreparacionfecha)) {
        this.errorin =
          'Favor colocar año, mes y día separado con guiones así: yyyy-mm-dd'
        return false
      }

      const [, anio, mes, dia] = this.vpreparacionfecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      // 3️⃣ Validar año lógico
      const anioActual = new Date().getFullYear()
      if (anioInt < 1900 || anioInt > anioActual + 1) {
        this.errorin = `El año debe estar entre 1900 y ${anioActual + 1}.`
        return false
      }

      if (mesInt < 1 || mesInt > 12) {
        this.errorin = 'El mes debe estar en el rango de 1 a 12.'
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        return false
      }

      // Validación de fecha real (extra por si acaso)
      const fechaObj = new Date(`${anioInt}-${mesInt}-${diaInt}`)
      if (isNaN(fechaObj.getTime())) {
        this.errorin = 'La fecha no es válida.'
        return false
      }
      this.errorin = ''
      return true
    },
    validarFechae(fechaString) {
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/

      // Reiniciar el error antes de validar
      this.errorFecha = ''

      if (!regexFecha.test(fechaString)) {
        this.errorFecha = 'Favor colocar año, mes y día en formato: YYYY-MM-DD'
      } else {
        let [, anio, mes, dia] = fechaString.match(regexFecha)

        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.errorFecha = 'El mes debe estar entre 1 y 12.'
          return
        }

        let diasEnMes = new Date(anio, mes, 0).getDate()
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.errorFecha = 'El día no es válido para el mes especificado.'
          return
        }

        // Si la fecha es válida, borra el error
        this.errorFecha = ''
      }
    },
    validarFechaCosecha(index) {
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      let fechaActual = this.cosecha[index].fecha

      // Reiniciar el error antes de validar
      this.errorFechaCosecha = ''

      if (!regexFecha.test(fechaActual)) {
        this.errorFechaCosecha = 'Formato incorrecto. Use YYYY-MM-DD'
      } else {
        let [, anio, mes, dia] = fechaActual.match(regexFecha)

        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.errorFechaCosecha = 'El mes debe estar entre 1 y 12.'
          return
        }

        let diasEnMes = new Date(anio, mes, 0).getDate()
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.errorFechaCosecha = 'El día no es válido para el mes.'
          return
        }

        // Si la fecha es válida, borra el error
        this.errorFechaCosecha = ''
      }
    },

    ////  AQUI se debera ver si aplica validar cada una del arreglo
    alertSurfaceOverflow() {
      this.alertar_superficie_mayor = ''
      if (this.registro.id_finca) {
        this.alertar_superficie_mayor =
          this.sumaDeSuperficiesDeCosechas +
            parseInt(this.registro.superficie_cosechada) >
          this.finca(this.registro.id_finca)?.extension
            ? 'La suma de las superficies cosechadas para este año, coa y finca exceden la superficie de la finca'
            : ''
      }
    },

    /* async buscarRegistroExistente() {
        const registrop = await this.obtenerPreparacion()
        this.registro_existente = registrop
      this.modal_registro_existe = false
      return false
    }, */
    limpiarRegistrosVacios() {
      this.siembraItems = this.siembraItems.filter((item) =>
        this.esSiembraValida(item)
      )
      this.cosecha = this.cosecha.filter((item) => this.esCosechaValida(item))
      if (this.registro.destinos) {
        //si el arrelgo no tiene estos campos llenos (los obligatorios de destino) lo limpia []
        this.registro.destinos = this.registro.destinos.filter(
          (destino) => destino.rubro
        )
      }
    },
    async guardarYContinuar() {
      //console.log('Guardando siembra:', this.siembra)
      this.limpiarRegistrosVacios()
      try {
        this.loading = true
        if (!this.$refs.form.validate()) {
          this.$store.commit('ui/setSnack', {
            text: 'Verifique los elementos en rojo',
            color: 'error',
          })
          return ''
        }
        //AQUI VALIDACION VENTAS
        const destinos = this.registro.destinos || []
        const tieneDestino =
          destinos.length > 0 && destinos.every((d) => d.rubro)
        const tieneCosechaValida = this.cosecha?.some(
          (p) =>
            p.id_cultivo &&
            p.fecha &&
            p.superficie_cosechada != null &&
            p.produccion != null &&
            p.superficie_perdida != null
        )

        const tieneSiembraValida = this.siembraItems?.some(
          (p) =>
            p.ID_CULTIVO &&
            p.VOLUMEN_ANUAL_PRODUCCION != null &&
            p.FECHA_ESTIMADA_COSECHA
        )
        const tieneProduccionValida = tieneCosechaValida || tieneSiembraValida
        if (tieneDestino && !tieneProduccionValida) {
          this.$store.commit('ui/setSnack', {
            text: 'Recuerde registrar al menos una siembra o cosecha antes de guardar una venta',
            color: 'error',
          })
          return
        }
        // Validar los campos obligatorios por cada destino (venta)
        if (tieneDestino) {
          for (const venta of this.registro.destinos) {
            const { fecha, produccion, precio, id_destino } = venta

            if (!fecha) {
              this.$store.commit('ui/setSnack', {
                text: 'Recuerde ingresar la fecha de su venta.',
                color: 'error',
              })
              return
            }

            if (
              produccion === null ||
              produccion === '' ||
              produccion === undefined
            ) {
              this.$store.commit('ui/setSnack', {
                text: 'Recuerde ingresar la cantidad de su venta.',
                color: 'error',
              })
              return
            }

            if (precio === null || precio === '' || precio === undefined) {
              this.$store.commit('ui/setSnack', {
                text: 'Recuerde ingresar su precio. Si no tiene precio, por favor ponga 0.',
                color: 'error',
              })
              return
            }

            if (!id_destino) {
              this.$store.commit('ui/setSnack', {
                text: 'Recuerde ingresar el destino de su venta.',
                color: 'error',
              })
              return
            }
          }
        }

        if (!Array.isArray(this.preparacion)) {
          this.$set(this, 'preparacion', []) // Inicializar como array vacío si no lo es
        }
        // MOD: Caso 1 -> NO hay preparacion, SÍ hay siembra con datos, y NO hay cosecha usada para bootstrap
        if (!this.preparacion.length && this.siembraItems.length) {
          const s0 = this.siembraItems[0] || {}
          const nuevaPreparacionDesdeSiembra = {
            id: uuid(),
            id_finca: this.vpreparacionid_finca || '',
            id_parcela: this.vpreparacionid_parcela || '',
            id_cultivo: s0?.ID_CULTIVO || '',
            variedad_cultivo: s0?.VARIEDAD || '',
            superficie_preparada: s0?.superficie_preparada || 0,
            fecha:
              this.vpreparacionfecha || new Date().toISOString().split('T')[0],
            coa: this.vpreparacioncoa || '',
            ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
            semilla: s0?.SEMILLA || '',
            financiamiento: this.vpreparacionfinanciamiento || '',
            tipo_prima_seguro: this.vpreparaciontipo_prima_seguro || '',
            estatus: 'A',
            created_at: new Date().getTime() / 1000,
          }
          this.$set(this.preparacion, 0, nuevaPreparacionDesdeSiembra)
          await this.$store.dispatch(
            'registros/guardarPreparacion',
            clona(nuevaPreparacionDesdeSiembra)
          )
        }

        if (!this.siembraItems.length && !this.preparacion.length) {
          const nuevaPreparacion = {
            id: uuid(),
            id_finca: this.vpreparacionid_finca || '',
            id_parcela: this.vpreparacionid_parcela || '',
            id_cultivo: this.cosecha[0]?.id_cultivo || '',
            variedad_cultivo: this.cosecha[0]?.variedad_cultivo || '',
            superficie_preparada: 0,
            fecha:
              this.vpreparacionfecha || new Date().toISOString().split('T')[0],
            coa: this.vpreparacioncoa || '',
            ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
            semilla: this.cosecha[0]?.semilla || '',
            financiamiento: this.vpreparacionfinanciamiento || '',
            tipo_prima_seguro: this.vpreparaciontipo_prima_seguro || '',
            estatus: 'A',
            created_at: new Date().getTime() / 1000,
          }

          this.$set(this.preparacion, 0, nuevaPreparacion)
          await this.$store.dispatch(
            'registros/guardarPreparacion',
            clona(nuevaPreparacion)
          )
        }

        // MOD: Caso 3 -> NO hay preparacion, NO hay siembra, NO hay cosecha, PERO hay destino con datos
        if (
          !this.preparacion.length &&
          !this.siembraItems.length &&
          (!Array.isArray(this.cosecha) || !this.cosecha.length) &&
          Array.isArray(this.registro?.destinos) &&
          this.registro.destinos.length
        ) {
          const d0 = this.registro.destinos[0] || {}
          const nuevaPreparacionDesdeDestino = {
            id: uuid(),
            id_finca: this.vpreparacionid_finca || '',
            id_parcela: this.vpreparacionid_parcela || '',
            id_cultivo: d0?.rubro || '', // rubro como id_cultivo
            variedad_cultivo: '', // no viene de destino
            superficie_preparada: 0,
            fecha:
              this.vpreparacionfecha || new Date().toISOString().split('T')[0],
            coa: this.vpreparacioncoa || '',
            ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
            semilla: '', // no viene de destino
            financiamiento: this.vpreparacionfinanciamiento || '',
            tipo_prima_seguro: this.vpreparaciontipo_prima_seguro || '',
            estatus: 'A',
            created_at: new Date().getTime() / 1000,
          }
          this.$set(this.preparacion, 0, nuevaPreparacionDesdeDestino)
          await this.$store.dispatch(
            'registros/guardarPreparacion',
            clona(nuevaPreparacionDesdeDestino)
          )
        }
        // FIN MODS de bootstrap de PREPARACION

        let itemsParaPreparacion = Array.isArray(this.siembraItems)
          ? this.siembraItems
          : []
        for (let item of itemsParaPreparacion) {
          let estado = 0

          // ASIGNA SIEMBRAITEMS A PREPARACION PARA ACTUALIZARLA O SI ES NUEVO LO CREA EN PREPARACION
          for (let index = 0; index < this.preparacion.length; index++) {
            let pre = this.preparacion[index]
            if (
              pre.id === item.id_p &&
              pre.id_cultivo === item.ID_CULTIVO &&
              pre.variedad_cultivo === item.VARIEDAD &&
              pre.semilla === item.SEMILLA
            ) {
              this.$set(this.preparacion, index, {
                ...pre,
                id: item.id_p || uuid(),
                id_finca: this.vpreparacionid_finca || '',
                id_parcela: this.vpreparacionid_parcela || '',
                id_cultivo: item.ID_CULTIVO || '',
                variedad_cultivo: item.VARIEDAD || '',
                superficie_preparada: item.superficie_preparada || '',
                fecha: this.vpreparacionfecha || '',
                coa: this.vpreparacioncoa || '',
                ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
                semilla: item.SEMILLA || '',
                updated_at: new Date().getTime() / 1000,
                financiamiento: this.vpreparacionfinanciamiento || '',
                tipo_prima_seguro: this.vpreparaciontipo_prima_seguro || '',
                estatus: 'A',
              })
              estado = 1

              await this.$store.dispatch(
                'registros/guardarPreparacion',
                clona(this.preparacion[index])
              )
            }
          }
          if (estado === 0) {
            const nuevoObjeto = {
              id: uuid(),
              id_finca: this.vpreparacionid_finca || '',
              id_parcela: this.vpreparacionid_parcela || '',
              estatus: 'A',
              id_cultivo: item.ID_CULTIVO || '',
              variedad_cultivo: item.VARIEDAD || '',
              superficie_preparada: item.superficie_preparada || '',
              fecha: this.vpreparacionfecha || '',
              coa: this.vpreparacioncoa || '',
              ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
              semilla: item.SEMILLA || '',
              created_at: new Date().getTime() / 1000,
              financiamiento: this.vpreparacionfinanciamiento,
              tipo_prima_seguro: this.vpreparaciontipo_prima_seguro || '',
            }

            this.$set(this.preparacion, this.preparacion.length, nuevoObjeto)
            await this.$store.dispatch(
              'registros/guardarPreparacion',
              clona(nuevoObjeto)
            )
          }
        }

        if (!Array.isArray(this.siembra)) {
          this.$set(this, 'siembra', [])
        }

        for (let item of this.siembraItems) {
          let estado = 0
          const fechazq = new Date(item.FECHA_ESTIMADA_COSECHA)
          if (!isNaN(fechazq)) {
            item.FECHA_ESTIMADA_COSECHA = fechazq.toISOString().split('T')[0]
          } else {
            item.FECHA_ESTIMADA_COSECHA = null
          }

          for (let index = 0; index < this.siembra.length; index++) {
            let siem = this.siembra[index]
            if (item.ID_CULTIVO) {
              if (
                siem.ID === item.ID &&
                siem.ID_CULTIVO === item.ID_CULTIVO &&
                siem.VARIEDAD === item.VARIEDAD &&
                siem.SEMILLA === item.SEMILLA
              ) {
                this.$set(this.siembra, index, {
                  ...siem,
                  ID: item.ID || uuid(),
                  ID_ENC: item.ID_ENC,
                  fecha_preparacion: this.vpreparacionfecha || '',
                  FECHA_SIEMBRA: this.vpreparacionfecha || '',
                  ID_CULTIVO: item.ID_CULTIVO || '',
                  VARIEDAD: item.VARIEDAD || '',
                  COA: this.vpreparacioncoa,
                  ID_FINCA: this.vpreparacionid_finca || '',
                  ID_PARCELA: this.vpreparacionid_parcela || '',
                  REALIZA_TRAZABILIDAD: this.vsiembraREALIZA_TRAZABILIDAD || '',
                  tecnologias: this.vsiembratecnologias || [],
                  estatus: 'A',
                  ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
                  FECHA_ESTIMADA_COSECHA: item.FECHA_ESTIMADA_COSECHA,
                  VOLUMEN_ANUAL_PRODUCCION: item.VOLUMEN_ANUAL_PRODUCCION || 0,
                  SUPERFICIE_ACTUAL_SEMBRADA:
                    item.SUPERFICIE_ACTUAL_SEMBRADA || '',
                  CANTIDAD_SEMILLA: item.CANTIDAD_SEMILLA || '',
                  SEMILLA: item.SEMILLA || '',
                  updated_at: new Date().getTime() / 1000,
                })
                estado = 1
                await this.$store.dispatch(
                  'registros/guardarSiembra',
                  clona(this.siembra[index])
                )
              }
            }
          }

          if (estado === 0 && item.ID_CULTIVO) {
            const nuevoObjet = {
              ID: uuid(),
              fecha_preparacion: this.vpreparacionfecha || '',
              FECHA_SIEMBRA: this.vpreparacionfecha || '',
              ID_FINCA: this.vpreparacionid_finca || '',
              ID_PARCELA: this.vpreparacionid_parcela || '',
              ID_CULTIVO: item.ID_CULTIVO || '',
              VARIEDAD: item.VARIEDAD || '',
              COA: this.vpreparacioncoa,
              estatus: 'A',
              ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
              REALIZA_TRAZABILIDAD: this.vsiembraREALIZA_TRAZABILIDAD || '',
              tecnologias: this.vsiembratecnologias || [],
              FECHA_ESTIMADA_COSECHA: item.FECHA_ESTIMADA_COSECHA,
              VOLUMEN_ANUAL_PRODUCCION: item.VOLUMEN_ANUAL_PRODUCCION || 0,
              SUPERFICIE_ACTUAL_SEMBRADA: item.SUPERFICIE_ACTUAL_SEMBRADA || '',
              CANTIDAD_SEMILLA: item.CANTIDAD_SEMILLA || '',
              SEMILLA: item.SEMILLA || '',
              created_at: new Date().getTime() / 1000,
            }

            this.$set(this.siembra, this.siembra.length, nuevoObjet)
            await this.$store.dispatch(
              'registros/guardarSiembra',
              clona(nuevoObjet)
            )
          }
        }

        // COSECHA  ///////////////////////////////
        // if (!Array.isArray(this.registro)) {
        //   this.$set(this, 'registro', [])
        // }
        //console.log("ANTES UPDATE REGISTRO.DESTINO ANTES", this.registro.destinos)
        //se pasa de this.cosecha (item) hacia el OBJETO this.registro (reg) ////////////////

        if (!this.idCosechaPrincipal) {
          this.idCosechaPrincipal = uuid()
        }
        if (!Array.isArray(this.registro.cosecha)) {
          this.$set(this.registro, 'cosecha', [])
        }
        for (let item of this.cosecha) {
          let estado = 0
          // AQUI recorre this.registrso a ver si todos estan y si no lo añade a this.registro///////////////////////////////
          for (let index = 0; index < this.registro.cosecha.length; index++) {
            let reg = this.registro.cosecha[index]
            if (
              reg.id === item.id
              //reg.variedad_cultivo === item.variedad_cultivo
            ) {
              this.$set(this.registro.cosecha, index, {
                id: item.id || uuid(),
                idprin: this.idCosechaPrincipal,
                id_finca: this.vpreparacionid_finca || '',
                id_parcela: this.vpreparacionid_parcela || '',
                id_cultivo: item.id_cultivo || '',
                variedad_cultivo: item.variedad_cultivo || '',
                semilla: item.semilla || '',
                fecha: item.fecha || '',
                fecha_preparacion: this.vpreparacionfecha || '',
                //id_enc: item.id_enc || '',
                tiempo_produccion: item.tiempo_produccion || 0,
                superficie_cosechada: item.superficie_cosechada || 0,
                produccion: item.produccion || 0,
                superficie_perdida: item.superficie_perdida || 0,
                produccion_anual_estimada: 0,
                cantidad_vendida: item.cantidad_vendida || 0,
                precio_de_venta: 0,
                ingreso_anual: 0,
                ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
                observacion: this.vobservacion,
                coa: this.vpreparacioncoa || '',
                estatus: 'A',
                //destinos: destinosActualizados,
                updated_at: new Date().getTime() / 1000,
              })
              estado = 1
              /* await this.$store.dispatch(
                'registros/guardarCosecha',
                clona(this.gregistro[index])
              ) */
              this.registro.cosecha = this.registro.cosecha.filter(
                (item) => item.id_cultivo || item.variedad_cultivo
              )
              /* const payload = {
               id: this.idCosechaPrincipal,
               id_finca: this.vpreparacionid_finca || '',
               id_parcela: this.vpreparacionid_parcela || '',
               fecha: this.vpreparacionfecha || '',
               producciones: this.registro.cosecha,
               destinos: this.registro.destinos || [],
             };

         await this.$store.dispatch('registros/guardarCosecha', clona(payload)) */
            }
          }

          if (estado === 0) {
            const nuevoRegistro = {
              id: uuid(),
              idprin: this.idCosechaPrincipal,
              id_cultivo: item.id_cultivo || '',
              variedad_cultivo: item.variedad_cultivo || '',
              semilla: item.semilla || '',
              fecha: item.fecha || '',
              fecha_preparacion: this.vpreparacionfecha || '',
              //id_enc: item.id_enc || '',
              tiempo_produccion: item.tiempo_produccion || 0,
              superficie_cosechada: item.superficie_cosechada || 0,
              produccion: item.produccion || 0,
              superficie_perdida: item.superficie_perdida || 0,
              produccion_anual_estimada: 0,
              cantidad_vendida: item.cantidad_vendida || 0,
              precio_de_venta: 0,
              ingreso_anual: 0,
              ley_de_beneficio: this.vpreparacionley_de_beneficio || '',
              observacion: this.vobservacion,
              coa: this.vpreparacioncoa,
              estatus: 'A',
              id_finca: this.vpreparacionid_finca || '',
              id_parcela: this.vpreparacionid_parcela || '',
              //destinos: destinosActualizados,
              created_at: new Date().getTime() / 1000,
            }
            this.$set(
              this.registro.cosecha,
              this.registro.cosecha.length,
              nuevoRegistro
            )
          }
        }

        this.registro.cosecha = this.registro.cosecha.filter(
          (item) => item.id_cultivo || item.variedad_cultivo
        )
        const payload = {
          id: this.idCosechaPrincipal,
          id_finca: this.vpreparacionid_finca || '',
          id_parcela: this.vpreparacionid_parcela || '',
          fecha: this.vpreparacionfecha || '',
          producciones: this.registro.cosecha,
          destinos: this.registro.destinos || [],
        }

        await this.$store.dispatch('registros/guardarCosecha', clona(payload))
        //CON ESTO REGRRESA A LA PANTALLA DE COSECHAS
        this.$router.push(`/ru/${this.ruta_registros}`)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    debounceBuscarRegistroExistente: debounce(async function () {
      //await this.buscarRegistroExistente()
    }, 1500),

    async cargarRegistroExistente() {
      /*  const id = this.registro_existente.id
      this.modal_registro_existe_loading = true
      if (!this.existeRegistroEnState('preparaciones', id)) {
        await this.cargarRegistroDelServer(this.registro_existente)
      } */
      this.cerrarModalRegistroExistente()
      this.modal_registro_existe_loading = false
    },

    obtenerIdDeRuta() {
      //se quito el .id
      return this.$route.params || ''
    },

    //En guardar
    /* async obtenerUnRegistroONada() {
      try {
        if (this.idProductor) {
          const response = await this.$store.dispatch('registros/getCosecha', {
            id: '',
            id_productor: this.idProductor,
            id_finca: this.idFinca,
            id_parcela: this.idParcela,
            fecha_preparacion: this.fecha,
          })
          return response
        }
        return []
      } catch (e) {
        return {}
      }
    }, */
    async obtenerUnRegistroONada() {
      try {
        //console.log('id_productor', this.idProductor)
        if (this.idProductor) {
          const response = await this.$store.dispatch('registros/getCosecha', {
            id: this.idCosechaPrincipal,
            id_productor: this.idProductor,
            id_finca: this.idFinca,
            id_parcela: this.idParcela,
            fecha_preparacion: this.fecha,
          })
          return response
        }
        return []
      } catch (e) {
        return {}
      }
    },
    async obtenerPreparacion() {
      try {
        if (this.idProductor) {
          const response = await this.$store.dispatch(
            'registros/getPreparacion',
            {
              id: '',
              id_productor: this.idProductor,
              id_finca: this.idFinca,
              id_parcela: this.idParcela,
              fecha: this.fecha,
            }
          )
          // la respuesta NO devuelve STATUS ni DATA
          // porque GETREGISTRO obtiene lo que esta dentro de data.

          return response
        }
        return []
      } catch (error) {
        console.error('Error al obtener los datos:', error)
        //return [];
      }
    },
    async obtenerSiembra() {
      try {
        if (this.idProductor) {
          const response = await this.$store.dispatch('registros/getSiembra', {
            id: '',
            id_productor: this.idProductor,
            id_finca: this.idFinca,
            id_parcela: this.idParcela,
            fecha_preparacion: this.fecha,
          })
          return response
        }
        return []
      } catch (e) {
        return {}
      }
    },
    // agrega un objeto de financiamiento al arreglo de financiamientos de la finca
    agregarFinanciamiento() {
      this.finca.financiamientos.push({ ...finca_financiamiento })
    },
    // remueve un financiamiento del arreglo de financiamientos
    removerFinanciamiento(index) {
      if (this.puedeRemoverFinanciamiento) {
        this.finca.financiamientos.splice(index, 1)
      }
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
    // Método para calcular los años agrícolas con inicio en 1 de mayo y fin en 30 de abril del año siguiente
    calculaAniosAgricolas() {
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth()

      // Si estamos antes de mayo, tomamos el año anterior como inicio
      const startYear = currentMonth < 4 ? currentYear - 1 : currentYear

      for (let i = 0; i < 10; i++) {
        const yearStart = startYear - i
        const yearEnd = yearStart + 1
        this.aniosAgricolas.push(`${yearStart}-${yearEnd}`)
      }
      for (let i = 1; i <= 2; i++) {
        const futureYearStart = startYear + i
        const futureYearEnd = futureYearStart + 1
        this.aniosAgricolas.unshift(`${futureYearStart}-${futureYearEnd}`)
      }
    },
    // Método para establecer el año agrícola por defecto
    setDefaultAnioAgricola() {
      // Verificar si el registro ya tiene un año agrícola definido
      if (!this.registro.anio_agricola) {
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth()

        // Si estamos antes de mayo, tomamos el año anterior como inicio
        const startYear = currentMonth < 4 ? currentYear - 1 : currentYear
        const defaultAnioAgricola = `${startYear}-${startYear + 1}`

        if (this.aniosAgricolas.includes(defaultAnioAgricola)) {
          this.registro.anio_agricola = defaultAnioAgricola
        } else {
          this.registro.anio_agricola = this.aniosAgricolas[0]
        }
      }
    },
  },
}
</script>

<style>
.custom-table {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ccc;
}

.custom-table th.header {
  font-size: 15px;
}
.custom-table th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

table {
  /*margin: auto;*/
  width: 40%;
  border-collapse: collapse;
}

td,
th {
  padding: 8px;
  text-align: left;
  border: 1px solid rgb(157, 157, 157);
}

.v-data-table {
  border: 1px solid #ddd;
  border-collapse: collapse;
  width: 100%;
}
</style>
